interface ValidationData {
  [property: string]: {
    link: string
    title: string
  }
}
export const ForSelforOtherValidationsMsgData: ValidationData = {
  DoDForOther: {
    link: '#',
    title: 'You cannot create an Other inquiry for yourself. Please enter a different DoD ID Number',
  },
  DoDNumberSelf: {
    link: '#',
    title: 'The DoD ID Number is assigned to another user. Please enter a different DoD ID Number',
  },
  EmailChange: {
    link: '#',
    title: `The customer's duty email is no longer valid or may have changed. Please contact the customer to update their profile.`
  }, 
  EmailForOther: {
    link: '#',
    title: 'You cannot create an Other inquiry for yourself. Please enter a different Duty Email',
  }
}

export const InquiryFormValidationMsgData: ValidationData = {
  AssignedComponent: {
    link: '#',
    title: 'You cannot save or submit a "For Other" inquiry for a user assigned to a component different than your assigned component.',
  },
  AssignedComponentCode: {
    link: '#',
    title: 'Select a valid Assigned Component',
  },
  CategoryCode: {
    link: '#',
    title: 'Category',
  },
  CustomerStatus: {
    link: '#',
    title: 'Select a valid Status',
  },
  Description: {
    link: '#',
    title: 'Description',
  },
  DoDNumber: {
    link: '#',
    title: 'Enter a valid DoD ID Number',
  },
  DutyEmail: {
    link: '#',
    title: 'Enter a valid Duty Email',
  },
  DutyPhone: {
    link: '#',
    title: 'Enter Duty Phone Number',
  },
  Installation: {
    link: '#',
    title: 'Select a valid Assigned Location',
  },
  Organization: {
    link: '#',
    title: 'Select a valid Organization',
  },
  PASCODE: {
    link: '#',
    title: 'Enter a valid PASCODE',
  },
  Rank: {
    link: '#',
    title: 'Select a valid Rank',
  },
  Subject: {
    link: '#',
    title: 'Subject',
  },
}